import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup
    .string()
    .min(4, 'Insira no mínimo 4 caracteres')
    .matches(/^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'\s]+$/, 'Insira apenas letras')
    .test('no-leading-trailing-spaces', 'Nome não pode conter espaços no início ou fim', (value) => {
      if (!value) return true;
      return !/^\s|\s$/.test(value);
    })
    .required()
    .test(`test-name-complete-length`, 'Digite o nome completo.', (value) => {
      if (
        value &&
        value
          .trim()
          .split(' ')
          .filter((word) => word.length > 0).length > 1
      )
        return true;
      return false;
    })
});

export default schema;
